  import React, { useEffect, useState } from "react";
  import { useLocation } from "react-router-dom";
  import data from "../../assets/db/main-db.json"; 

  const ModelWiseStock = () => {
    const location = useLocation();
    const { filteredModels, brandName } = location.state || {};
    const [modelStock, setModelStock] = useState([]);
    const [showInStockOnly, setShowInStockOnly] = useState(false);

    useEffect(() => {
      if (!filteredModels || !brandName) return;

      // Find the selected brand in the data
      const brandData = data.brands.find((brand) => brand.name === brandName);

      if (brandData) {
        // Calculate model-wise stock
        const stockByModel = filteredModels.reduce((acc, item) => {
          acc[item.model] = (acc[item.model] || 0) + 1;
          return acc;
        }, {});

        // Transform the stock data for all models in the selected brand
        const formattedStock = brandData.models.map((model) => ({
          name: model.name,
          imageUrl: model.imageUrl,
          stock: stockByModel[model.name] || 0, // Default stock to 0 if unavailable
        }));

        setModelStock(formattedStock);
      }
    }, [filteredModels, brandName]);

    // Filter models based on the showInStockOnly state
    const filteredModelStock = showInStockOnly
      ? modelStock.filter((model) => model.stock > 0)
      : modelStock;

    return (
      <div className="p-6 bg-white h-full" style={{ minHeight: "100vh" }}>
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-bold mb-4">
            {brandName ? `${brandName} Models` : "All Models"}
          </h1>
          <button
            onClick={() => setShowInStockOnly(!showInStockOnly)}
            className="px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-600 transition w-1/6"
          >
            {showInStockOnly ? "Show All Brands" : "Show Brands in Stock"}
          </button>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {filteredModelStock.map((model, index) => (
            <div
              key={index}
              className="border rounded-lg p-4 flex flex-col items-center shadow hover:shadow-lg transition bg-gray-50"
            >
              <img
                src={model.imageUrl}
                alt={model.name}
                className="w-16 h-16 object-contain mb-2 mix-blend-multiply"
              />
              <p className="text-sm font-normal text-gray-800">{model.name}</p>
              <div className="mt-2 w-full text-center bg-gray-200 rounded-lg py-1">
                <p
                  className={`text-sm font-medium ${
                    model.stock === 0 ? "text-red-500" : "text-green-500"
                  }`}
                >
                  Stock: {model.stock}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  export default ModelWiseStock;
